import { createFileRoute } from '@tanstack/react-router';

import { getConferenceOptions } from '@/module/Conference';

export const Route = createFileRoute('/_auth/conference/_conference/$conferenceId/_layout')({
  loader: async ({ params: { conferenceId }, context: { queryClient } }) => {
    const conference = await queryClient.ensureQueryData(getConferenceOptions(conferenceId));

    return {
      conference,
      crumb: conference.conferenceName,
    };
  },
});
